/* @jsxImportSource react */

import {
  NewEnergyEfficiencyFlag,
  type NewEnergyEfficiencyFlagProps,
} from './NewEnergyEfficiencyFlag/NewEnergyEfficiencyFlag';
import {
  LegacyEnergyEfficiencyFlag,
  type LegacyEnergyEfficiencyFlagProps,
} from './LegacyEnergyEfficiencyFlag/LegacyEnergyEfficiencyFlag';

export type EnergyEfficiencyFlagProps =
  | ({ variant: 'legacy' } & LegacyEnergyEfficiencyFlagProps)
  | ({ variant: 'new' } & NewEnergyEfficiencyFlagProps);

export const EnergyEfficiencyFlag = (props: EnergyEfficiencyFlagProps) =>
  props?.variant === 'legacy' ? (
    <LegacyEnergyEfficiencyFlag {...props} />
  ) : (
    <NewEnergyEfficiencyFlag {...props} />
  );

EnergyEfficiencyFlag.displayName = 'EnergyEfficiencyFlag';
